import {
  LabelStyled,
  LabelContentStyled,
  TextStyled,
  SubTextStyled,
} from '@procurify/ui'
import styled from 'styled-components'

interface IApprovalPoolLabelStyledProps {
  fluid?: boolean
}

export const ApprovalPoolLabelStyled = styled.div<IApprovalPoolLabelStyledProps>`
  display: inline-flex;
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  ${LabelStyled} {
    align-items: center;
    background: transparent;

    /*
     * Labels defined a max width of 180px if not fluid. For ApprovalPoolLabel, that's a little tight.
     * We're overriding this to define a slightly larger max width when fluid is false
     */
    ${(props) => {
      if (!props.fluid) {
        return `max-width: ${props.theme.typography.pxToRem(250)};`
      }
    }}

    ${LabelContentStyled} {
      font-weight: ${(props) => props.theme.typography.fontWeightRegular};
      padding-right: 0;

      ${TextStyled} {
        line-height: 1.2;
        margin-bottom: ${(props) => props.theme.typography.pxToRem(4)};
      }

      ${SubTextStyled} {
        margin-top: ${(props) => props.theme.typography.pxToRem(2)};
      }
    }
  }
`
